import { FC, Fragment, useCallback, useEffect, useState } from "react";
import { ITreasuryTokenAccInfo } from "../../../../../common/interfaces/clubs.interface";
import "./MintSelect.scss";
import TokenInfo from "../../../../TokenInfo/TokenInfo";
import searchTokenIcon from "../../../../../assets/searchTokenIcon.svg";
import arrowDown from "../../../../../assets/arrowBottom.svg";
import arrowUp from "../../../../../assets/arrowUp.svg";
import { NATIVE_MINT } from "@solana/spl-token";
import { TOKEN_LIST_RENDER_ITEMS_NUMBER } from "../../../../../common/constants/common.constants";

const MintSelect: FC<{
  treasuryTokenAccounts: ITreasuryTokenAccInfo[];
  isForm?: boolean;
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void;
  setChosenCurrency?: (tokenInfo: ITreasuryTokenAccInfo) => void;
  isFundraisingConfig?: boolean;
  chosenMint: string | undefined;
  isDisabled?: boolean;
}> = ({
  treasuryTokenAccounts,
  isForm,
  setFieldValue,
  chosenMint,
  isFundraisingConfig,
  setChosenCurrency,
  isDisabled,
}) => {
  const [chosenTokenAcc, setChosenTokenAcc] = useState<
    ITreasuryTokenAccInfo | undefined
  >();

  useEffect(() => {
    setChosenTokenAcc(
      treasuryTokenAccounts.find((item) =>
        chosenMint
          ? item.mint.toString() === chosenMint
          : item.mint.toString() === NATIVE_MINT.toString()
      )
    );
  }, [chosenMint]);

  const [filteredTokens, setFilteredTokens] = useState(treasuryTokenAccounts);
  const [isSelectVisible, toggleSelect] = useState(false);

  const searchTokens = (searchValue: string) => {
    setFilteredTokens(
      treasuryTokenAccounts.filter((item) =>
        item.name.toLowerCase().includes(searchValue)
      )
    );
  };

  const updateChosenTA = useCallback(
    (ta: ITreasuryTokenAccInfo) => {
      isForm && setFieldValue && setFieldValue("mint", ta.mint);
      isForm && setFieldValue && setFieldValue("tokenAddress", ta.tokenAddress?.toString() || null);
      if (isFundraisingConfig && setFieldValue) {
        setFieldValue("mintSymbol", ta.symbol);
        setFieldValue("mintDecimals", ta.decimals);
      }
      setChosenCurrency && setChosenCurrency(ta);
      setChosenTokenAcc(ta);
      toggleSelect(false);
    },
    [isForm, isFundraisingConfig, setFieldValue]
  );

  return (
    <div
      className={`mint-select ${isDisabled && "mint-select--disabled"}`}
      onClick={() => !isDisabled && toggleSelect(!isSelectVisible)}
    >
      <div className="mint-select__option">
        <p
          className={`mint-select__chosen-option ${
            isDisabled && "mint-select__chosen-option--disabled"
          }`}
        >
          {chosenTokenAcc?.symbol}
        </p>
        {!isDisabled && (
          <img
            src={!isSelectVisible ? arrowDown : arrowUp}
            alt="arrowDownIcon"
            className="mint-select__arrow"
          />
        )}
        {isSelectVisible && !isDisabled && (
          <Fragment>
            <div
              className="mint-select__list"
              onClick={() => toggleSelect(!isSelectVisible)}
            ></div>
            <div
              className="mint-select__list-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mint-select__search-input">
                <input
                  type="text"
                  placeholder="Type to filter..."
                  onChange={(e) => searchTokens(e.target.value)}
                />
                <img src={searchTokenIcon} alt="Token logo" />
              </div>
              {filteredTokens.length > 0 && !isFundraisingConfig && (
                <p className="mint-select__available-tokens">Available</p>
              )}
              {filteredTokens.map((item, index) => (
                <div
                  key={item.tokenAddress?.toString()}
                  onClick={() => {
                    updateChosenTA(item);
                  }}
                >
                  {index < TOKEN_LIST_RENDER_ITEMS_NUMBER && (
                    <TokenInfo
                      balance={item.balance}
                      image={item.image}
                      name={item.name}
                      symbol={item.symbol}
                      isFundraisingConfig={isFundraisingConfig}
                    />
                  )}
                </div>
              ))}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default MintSelect;
